import React from 'react';
import EditProfileLink from '../../../common/EditProfileLink/EditProfileLink';
import { Heading } from 'wix-style-react';
import s from './expertDataTitle.scss';

const ExpertDataTitle = ({ title, tabName, showEditProfileLink }) => {
  return (
    <div className={s.root}>
      <Heading appearance="H2">{title}</Heading>
      {showEditProfileLink && (
        <div className={s.editProfileLinkWrapper} data-hook="edit-profile-link">
          <EditProfileLink tabName={tabName} />
        </div>
      )}
    </div>
  );
};

export default ExpertDataTitle;
